import { z } from 'zod';
import { DecimalString } from './common.js';

const optionalAmount = DecimalString.optional();

export const LineageTransferSchema = z
  .object({
    to_username: z.string().min(1).max(32),
    amount_rp: optionalAmount,
    amount_tp: optionalAmount,
    amount_fc: optionalAmount,
    transaction_password: z.string().min(1).max(128),
    security_answer: z.string().min(1).max(256),
    memo: z.string().max(500).optional(),
  })
  .superRefine((data, ctx) => {
    const positive = ['amount_rp', 'amount_tp', 'amount_fc'].filter((k) => {
      const v = data[k as keyof typeof data];
      if (typeof v !== 'string' || !v) return false;
      try {
        return parseFloat(v) > 0;
      } catch {
        return false;
      }
    });
    if (positive.length < 2) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'at least two of RP, TP, FC amounts must be > 0',
        path: ['amount_rp'],
      });
    }
  });

export type LineageTransferRequest = z.infer<typeof LineageTransferSchema>;

export const LineageSingleTransferSchema = z.object({
  asset: z.enum(['rp', 'tp', 'fc']),
  amount: DecimalString,
  to_username: z.string().min(1).max(32),
  transaction_password: z.string().min(1).max(128),
  security_answer: z.string().min(1).max(256),
  memo: z.string().max(500).optional(),
});

export type LineageSingleTransferRequest = z.infer<typeof LineageSingleTransferSchema>;

export const LineageTransferPreviewQuerySchema = z.object({
  to_username: z.string().min(1).max(32),
});

export const LineageSinglePreviewQuerySchema = z.object({
  to_username: z.string().min(1).max(32),
  asset: z.enum(['rp', 'tp', 'fc']),
});
